import { Flex, Box } from "grid-styled";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { track } from "../../analytics";
import styled from "../../styled-components";
import { media } from "../../breakpoints";

const Wrapper = styled.a`
  border-radius: 3px;
  padding: 15px;
  text-decoration: none;
  cursor: pointer;
  float: right;
  max-width: 421px;

  ${media.TABLET`
    left: 0;
    margin: 0 auto;
    width: 100%;
    max-width: 100%;
    right: 0;
    padding: 0 15px;
  `};
  @media screen and (max-width: 330px) {
    padding: 5px;
  }
`;

const SubWrapper = styled(Flex)`
  align-items: center;
  flex-direction: row;
  @media screen and (max-width: 915px) and (min-width: 768px) {
    flex-direction: column;
  }

  ${media.TABLET`
    justify-content: center;
    width: 100%;
  `};

  ${media.PHONE`
    justify-content: space-between;
  `};
  @media screen and (max-width: 330px) {
    flex-direction: column;
  }
`;

const Title = styled.p`
  color: ${props => props.theme.colors.black};
  font-weight: 600;
  text-transform: uppercase;

  ${media.TABLET`
    margin-top: 2px;
    font-size: 12px;
  `};
`;

const Description = styled(Box)`
  color: ${props => props.theme.colors.black};
  font-size: 14px;
  margin: 0 0 0 12px;
  padding: 10px;
  border: 1px solid #b2b2b2;
  border-radius: 20px;
  text-align: center;
  @media screen and (max-width: 915px) and (min-width: 768px) {
    margin: 10px auto 0 auto;
    width: 100%;
    text-align: center;
  }

  @media screen and (max-width: 767px) {
    margin: 0 0 0 35px;
  }

  ${media.PHONE`
    margin: 0;
  `};
  @media screen and (max-width: 330px) {
    margin: 10px auto 0 auto;
    width: 100%;
    text-align: center;
  }
`;

interface IEarningsCallBannerProps extends RouteComponentProps<{}> {}

// TODO: Make this component more generic, not tited to Tesla
const EarningsCallBanner: React.SFC<IEarningsCallBannerProps> = props => {
  const handleBannerClick = () => {
    track("Earnings Call Banner Clicked");
    window.location.href = `https://saytechnologies.com/earnings/twitter`;
  };

  return (
    <Wrapper onClick={handleBannerClick}>
      <SubWrapper>
        <Title>Upcoming Earnings Call</Title>

        <Description>Ask Twitter a question.</Description>
      </SubWrapper>
    </Wrapper>
  );
};

export default withRouter(EarningsCallBanner);



// WEBPACK FOOTER //
// ./src/components/EarningsCallBanner/EarningsCallBanner.tsx